export const B={
  blue: "#2E5FA7",
  darkBlue: "#244C86",
  navy: "#0D1B2E",
  navyMid: "#122240",
  navyCard: "#1A2E4A",
  navyBorder: "#1E3A5F",
  red: "#C0392B",
  orange: "#E67E22",
  yellow: "#F1C40F",
  green: "#27AE60",
  teal: "#16A085",
  white: "#FFFFFF",
  lightGray: "#B0BEC5",
  subText: "#7A9BBE",
  accent: "#5BA3E0",
};

export const PILLARS=[
  {
    id: "modernize",label: "Modernize",sub: "Cloud · M365",color: B.blue,icon: "☁️",
    questions: [
      {id: "m1",label: "Cloud Infrastructure",opts: ["100% on-prem","SaaS apps only","Hybrid partial","Full cloud-first","Multi-cloud optimized"]},
      {id: "m2",label: "M365 Adoption",opts: ["No M365 / legacy","M365 Basic email only","M365 Business Standard","M365 Business Premium","Full E5 + Copilot"]},
      {id: "m3",label: "Collaboration Tools",opts: ["Email only","Teams for messaging","Teams + SharePoint","Full Teams governance","Integrated automation"]},
    ],
  },
  {
    id: "operate",label: "Operate",sub: "Monitoring · IT",color: B.green,icon: "⚙️",
    questions: [
      {id: "o1",label: "Help Desk & Support",opts: ["Internal only / break-fix","Occasional break-fix vendor","Co-managed IT","Fully managed MSP","Strategic NOC + vCIO"]},
      {id: "o2",label: "Network Infrastructure",opts: ["Unmanaged switches/WiFi","Basic managed switch","Managed + segmentation","SD-WAN deployed","SASE / zero-trust network"]},
      {id: "o3",label: "Backup & Disaster Recovery",opts: ["No backup or USB only","Local NAS backup","Cloud backup","Cloud + tested DR plan","Immutable backup + BCP"]},
    ],
  },
  {
    id: "secure",label: "Secure",sub: "Cybersecurity",color: B.red,icon: "🔒",
    questions: [
      {id: "s1",label: "Endpoint Protection",opts: ["Basic AV only","AV + managed firewall","MDR (Managed Detection & Response)","MDR/XDR + SOC","AI-driven XDR + human threat hunt"]},
      {id: "s2",label: "Identity & Access",opts: ["Shared passwords,no MFA","MFA on email only","MFA across key apps","SSO + conditional access","Zero-trust identity platform"]},
      {id: "s3",label: "Security Awareness",opts: ["No training","Annual basic training","Quarterly + simulations","Monthly + phishing sims","Continuous adaptive training"]},
    ],
  },
  {
    id: "ai",label: "AI & Automation",sub: "Intelligence · Process",color: "#9B59B6",icon: "🤖",
    questions: [
      {id: "a1",label: "AI Tool Adoption",opts: ["No AI awareness","Exploring AI concepts","Piloting Copilot / ChatGPT","M365 Copilot deployed","Custom AI agents + workflows"]},
      {id: "a2",label: "Process Automation",opts: ["No processes documented","Key processes informally noted","Core processes documented","Automated workflows (Power Automate)","AI-orchestrated end-to-end automation"]},
      {id: "a3",label: "Data Governance",opts: ["No data governance","Basic file naming conventions","Some data classification","DLP + sensitivity labels","Governed data lake + AI-ready"]},
    ],
  },
  {
    id: "print",label: "Managed Print",sub: "Fleet · Document",color: B.orange,icon: "🖨️",
    questions: [
      {id: "p1",label: "Print Fleet Management",opts: ["Unmanaged / unknown devices","Basic inventory only","Monitored fleet (manual)","Managed Print Services (MPS)","Fully optimized MPS + analytics"]},
      {id: "p2",label: "Supply & Cost Control",opts: ["Manual ordering / overstocked","Reactive ordering","Scheduled ordering","Auto-fulfillment (zero-touch)","AI-driven supply optimization"]},
      {id: "p3",label: "Document Workflow",opts: ["Paper-based,no digitization","Some scanning to email","Scan to SharePoint/cloud","Automated document routing","Full DMS + workflow automation"]},
    ],
  },
];

export const INDUSTRY_BENCHMARKS={
  Healthcare: 2.6,"Financial Services": 3.1,Legal: 2.4,Nonprofit: 2.1,
  Government: 2.9,Manufacturing: 2.5,Construction: 2.0,Education: 2.3,
  Technology: 3.4,"Professional Services": 2.8,Retail: 2.2,Other: 2.5,
};

export const industryCallouts={
  Healthcare: "HIPAA Security Rule compliance requires documented risk assessments,access controls,and breach notification procedures.",
  "Financial Services": "SOX,PCI-DSS,and SEC cybersecurity rules require documented controls,MFA,and annual third-party risk assessments.",
  Legal: "ABA Ethics Rules and state bar requirements mandate client data confidentiality protections and incident response plans.",
  Nonprofit: "Donor PII and grant compliance requirements demand access controls,data retention policies,and secure document handling.",
  Government: "NIST 800-171 and CMMC frameworks may apply. All federal-adjacent entities must document security controls.",
  Manufacturing: "OT/IT convergence and supply chain risk require network segmentation and vendor access management.",
  Education: "FERPA compliance mandates student data privacy controls and documented data handling procedures.",
};